import { axiosDS } from '@pp/axios'
import { BusinessappsModel } from 'Pages/orders'
import { urls } from 'Constants/Urls'
import { ResponseCatalog } from 'Models'
import { DivisionModel } from 'Pages/registratorCabinet'

export const tariffsBlockApi = {
	getDivisions: async (params: { region_code?: string; query?: string }) => {
		const res = await axiosDS().get<DivisionModel[]>(urls.cabinet.divisions, { params })
		return res.data
	},
	getRegions: async () => {
		const res = await axiosDS().get<{ code: string; name: string }[]>(urls.cabinet.regions)
		return res.data
	},
	getBusinessapp: async (params: { okved_codes: string; status: string }) => {
		const res = await axiosDS().get<ResponseCatalog<BusinessappsModel>>(urls.cabinet.businessapp, {
			params,
		})
		return res.data
	},
}
